/* istanbul ignore file - better tested visually */

import { faClose } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { classNames } from '@partful/shared/lib/classNames';
import toast, { ToastBar, Toaster as HotToaster } from 'react-hot-toast';
import { Button } from '../Button';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import styles from './Toaster.module.scss';

export function Toaster() {
  return (
    <HotToaster
      position="top-right"
      toastOptions={{
        className: styles.toast,
        loading: {
          icon: <LoadingSpinner className={styles.loadingIcon} />,
        },
      }}
    >
      {(t) => (
        <span className={classNames(styles.toastWrapper, styles[t.type])}>
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== 'loading' && (
                  <Button icon size="small" variant="tertiary" onClick={() => toast.dismiss(t.id)}>
                    <FontAwesomeIcon icon={faClose} />
                  </Button>
                )}
              </>
            )}
          </ToastBar>
        </span>
      )}
    </HotToaster>
  );
}

export { toast } from 'react-hot-toast';
